/* accepts parameters
 * h  Object = {h:x, s:y, v:z}
 * OR 
 * h, s, v
*/
function HSVtoRGB(h: number, s: number, v: number) {
    var r, g, b, i, f, p, q, t;
    //if (arguments.length === 1) {
    //    s = h.s, v = h.v, h = h.h;
    //}
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}

function rgb2hex(c: any) {
    return '#' + [c.r, c.g, c.b].map(v => v.toString(16).padStart(2, '0')).join("")
}

export function hsv2hex(h: number, s: number, v: number) {
    let rgb = HSVtoRGB(h, s, v)
    return rgb2hex(rgb)
}
